import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { ExtendedPartSchema, QuoteRequestLineSchema, QuoteRequestSchema } from "../types";

const c = initContract();

export enum SearchEntity {
  QuoteRequestLine = "QuoteRequestLine",
  QuoteRequest = "QuoteRequest",
}

const SearchEntitySchema = z.nativeEnum(SearchEntity);

const QuoteRequestLineSearchResultSchema = z.object({
  type: z.literal(SearchEntity.QuoteRequestLine),
  quoteRequestLine: QuoteRequestLineSchema.extend({
    part: ExtendedPartSchema,
  }),
});

const QuoteRequestSearchResultSchema = z.object({
  type: z.literal(SearchEntity.QuoteRequest),
  quoteRequest: QuoteRequestSchema,
  clientName: z.string().nullable(),
  partCount: z.number().int().nonnegative(),
});

const SearchResultSchema = z.discriminatedUnion("type", [
  QuoteRequestLineSearchResultSchema,
  QuoteRequestSearchResultSchema,
]);

export const searchContract = c.router({
  search: {
    method: "GET",
    path: "/search",
    query: z.object({
      query: z.string(),
      entity: SearchEntitySchema.optional(),
      page: z.number().optional().default(1),
    }),
    responses: {
      200: z.object({
        data: z.array(SearchResultSchema),
        total: z.number(),
        page: z.number(),
      }),
    },
  },

  getRecentSearches: {
    method: "GET",
    path: "/search/recent",
    responses: {
      200: z.object({
        results: z.array(z.string()),
      }),
    },
  },

  deleteSearch: {
    method: "DELETE",
    path: "/search",
    body: z.object({
      query: z.string(),
    }),
    responses: {
      200: z.object({ success: z.boolean() }),
    },
  },
});
